import { isEqual } from "lodash";
import { useSelector } from "react-redux";
import { RootState } from "./rootState";
import { localStore, sessStore } from "./browserStore";

export function useRootSelector<R = unknown>(
    selector: (state: RootState) => R,
    equalityFn?: (left: R, right: R) => boolean
) {
    if (equalityFn === undefined) equalityFn = isEqual;
    return useSelector(selector, equalityFn);
}


export const useBrowserStore = (type: "session" | "local") =>
    type === "session" ? sessStore : localStore

